var map = {
	"./Cooking/AlooBhindi.jpeg": 5369,
	"./Cooking/BhindiPyaz.jpeg": 3317,
	"./Cooking/ChanaMasala.jpeg": 44,
	"./Cooking/FriedRice.jpeg": 1600,
	"./Cooking/Pizza.jpeg": 3595,
	"./Cooking/SoyaChilli.jpeg": 3716,
	"./Cooking/VeggiWraps.jpeg": 8906,
	"./Cooking/aloosabji.jpeg": 3943,
	"./Cooking/soojiUttapam.jpeg": 9321,
	"./ScreenShots/AskaDoc/AskaDocSS.png": 6244,
	"./ScreenShots/AskaDoc/Categories1.png": 8213,
	"./ScreenShots/AskaDoc/Categories2.png": 9243,
	"./ScreenShots/AskaDoc/ChatDtP.png": 7362,
	"./ScreenShots/AskaDoc/ChatPtD.png": 7274,
	"./ScreenShots/AskaDoc/DocProfile.png": 1285,
	"./ScreenShots/AskaDoc/DoctorList.png": 7387,
	"./ScreenShots/AskaDoc/Login.png": 5365,
	"./ScreenShots/AskaDoc/Signup.png": 5944,
	"./ScreenShots/AskaDoc/hp2.png": 3254,
	"./ScreenShots/AskaDoc/incompleteProfile.png": 7654,
	"./ScreenShots/Autograph/autograph.png": 3592,
	"./ScreenShots/CashCard/CC_Endpoints.png": 9897,
	"./ScreenShots/CashCard/CC_TestResults.png": 6917,
	"./ScreenShots/CashCard/ccfs_cclist.png": 6617,
	"./ScreenShots/CashCard/ccfs_endpoints.png": 4315,
	"./ScreenShots/CashCard/ccfs_landing.png": 6258,
	"./ScreenShots/CashCard/ccfs_login.png": 7309,
	"./ScreenShots/CashCard/ccfs_newcard.png": 819,
	"./ScreenShots/CashCard/ccfs_register.png": 6580,
	"./ScreenShots/Microservice/MS_EC_OM.png": 1603,
	"./ScreenShots/Microservice/MS_EC_PS.png": 3282,
	"./ScreenShots/OpenSkill/OpenSkill_LP.png": 5159,
	"./ScreenShots/OpenSkill/Openskill_jp_applications.png": 6911,
	"./ScreenShots/OpenSkill/Openskill_jp_jd.png": 9476,
	"./ScreenShots/OpenSkill/Openskill_jp_jobs.png": 6315,
	"./ScreenShots/OpenSkill/Openskill_js_applications.png": 2961,
	"./ScreenShots/OpenSkill/Openskill_js_apply.png": 5929,
	"./ScreenShots/OpenSkill/Openskill_js_jd.png": 3657,
	"./ScreenShots/OpenSkill/Openskill_js_jobs.png": 8292,
	"./ScreenShots/OpenSkill/Openskill_js_profile.png": 7650,
	"./ScreenShots/OpenSkill/Openskill_login.png": 9725,
	"./ScreenShots/OpenSkill/Openskill_signup.png": 4110,
	"./ScreenShots/Others/CarouselLeft.svg": 179,
	"./ScreenShots/Others/CarouselRight.svg": 9180,
	"./ScreenShots/Others/backendLogo.svg": 7956,
	"./ScreenShots/Others/codeChefLogo.svg": 576,
	"./ScreenShots/Others/codeforcesLogo.svg": 6363,
	"./ScreenShots/Others/cudaLogo.png": 4328,
	"./ScreenShots/Others/devToolsLogo.svg": 476,
	"./ScreenShots/Others/frontendLogo.svg": 2260,
	"./ScreenShots/Others/githubLogo.svg": 3342,
	"./ScreenShots/Others/hamMenu.svg": 7818,
	"./ScreenShots/Others/hardwareLogo.svg": 1439,
	"./ScreenShots/Others/highSchooLogo.svg": 6385,
	"./ScreenShots/Others/iitbbsLogo.png": 7322,
	"./ScreenShots/Others/instagramLogo.svg": 9967,
	"./ScreenShots/Others/intro_img.png": 4450,
	"./ScreenShots/Others/intro_img1.png": 6096,
	"./ScreenShots/Others/leetCodeLogo.svg": 7896,
	"./ScreenShots/Others/linkSvg.svg": 2334,
	"./ScreenShots/Others/linkedinLogo.svg": 5099,
	"./ScreenShots/Others/mailLogo.svg": 7881,
	"./ScreenShots/Others/reactLogo.svg": 5658,
	"./ScreenShots/Others/schoolLogo.svg": 4417,
	"./ScreenShots/Others/tabIcon.png": 2184,
	"./ScreenShots/Others/tabIcon.svg": 5999,
	"./ScreenShots/Others/trophy.svg": 6050,
	"./ScreenShots/Others/universityLogo.svg": 6095
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7548;